import Vue from 'vue'
import VueRouter from 'vue-router'
// import { component } from 'vue/types/umd';
// import store from "./../../src/store/index.js";
// import axios from "axios";
import store from "../store/index";


Vue.use(VueRouter)

const routes = [
//   {
//     path: '/header',
//     name: 'HeaderPage',
//     component: () => import("../components/HeaderAndFooter/HeaderPage.vue"),
//   },
//   {
//     path: '/footer',
//     name: 'FooterPage',
//     component: () => import("../components/HeaderAndFooter/FooterPage.vue"),
//   },
//   {
//     path: "/404",
//     name: '404Page',
//     component: () => import("../components/Common/404Page.vue"),
//   },

  {
    path: '/',
    name: 'LoginPage',
    component: () => import("../components/Common/LoginPage.vue"),
  },
  {
    path: '/forgotPassword',
    name: 'ForgotPassword',
    component: () => import("../components/Common/ForgotPassword.vue"),
    
  },
  {
    path: '/dashboard',
    name: 'DashboardPage',
    component: () => import("../components/home/DashboardPage.vue"),
    meta : {
      requiresAuth: true,
    }
  },
  {
    path: '/home',
    name: 'HomePage',
    component: () => import("../components/home/HomePage.vue"),
    meta : {
      requiresAuth: true,
    }
  },
  
  {
    path: '/sidebar',
    name: 'SidebarPage',
    component: () => import("../components/Common/SidebarPage.vue"),
    meta : {
      requiresAuth: true,
    },
    children: [
      {
        path: '/webpages',
        name: 'WebpagesPage',
        component: () => import("../components/home/WebpagesPage.vue"),
      },
      {
        path: '/category',
        name: 'CategoryPage',
        component: () => import("../components/home/CategoryPage.vue"),
      },
      {
        path: '/subCategory',
        name: 'SubcategoryPage',
        component: () => import("../components/home/SubcategoryPage.vue"),
      },
      {
        path: '/products',
        name: 'ProductPage',
        component: () => import("../components/home/ProductPage.vue"),
      },
      {
        path: '/sizes',
        name: 'SizesPage',
        component: () => import("../components/home/SizesPage.vue"),
      },
      {
        path: '/materialGroup',
        name: 'MaterialGroupPage',
        component: () => import("../components/home/MaterialGroupPage.vue"),
      },
      {
        path: '/material',
        name: 'MaterialPage',
        component: () => import("../components/home/MaterialPage.vue"),
      },

      {
        path: '/topCarousal',
        name: 'TopCarousal',
        component: () => import("../components/WebpageItems/TopCarousal.vue"),
      },
      {
        path: '/companyNameBanner',
        name: 'CompanyNameBanner',
        component: () => import("../components/WebpageItems/CompanyNameBanner.vue"),
      },
      {
        path: '/midCarousal',
        name: 'MidCarousal',
        component: () => import("../components/WebpageItems/MidCarousal.vue"),
      },
      {
        path: '/aboutUs',
        name: 'AboutUsPage',
        component: () => import("../components/home/AboutUsPage.vue"),
      },
      {
        path: '/contactUs',
        name: 'ContactUsPage',
        component: () => import("../components/home/ContactUsPage.vue"),
      },
      {
        path: '/quoteUs',
        name: 'QuoteUsPage',
        component: () => import("../components/home/QuoteUsPage.vue"),
      },
      {
        path: '/clientRatings',
        name: 'ClientRatingsPage',
        component: () => import("../components/home/ClientRatingsPage.vue"),
      },
    ],
  },

]

//   },
  
// ]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});


router.beforeEach((to, from, next) => {

  const leavingPage = ["ProductPage", "AnotherPage"].includes(from.name);
  const notEnteringPage = !["ProductPage", "AnotherPage"].includes(to.name);

  if (leavingPage && notEnteringPage) {
    // Reset currentPage only when leaving the relevant pages
    store.commit("changeCurrentPage", 1);
    localStorage.removeItem("currentPage"); // Clear from localStorage
  }

  if (
    to.matched.some((route) => route.meta.requiresAuth == true) &&
    store.state.isLoggedIn == false
  ) {
    console.log(from);
    next({ name: "LoginPage", params: { lastPage: from } });
    return;
  }


  // if (store.state.isLoggedIn) {
  //     axios({
  //       method: "GET",
  //       url: "/authenticate",
  //       headers: {
  //         token: localStorage.getItem("token"),
  //       },
  //     })
  //       .then((response) => {
  //         if (!response.data.status) {
  //           store.commit("sessionOut", true);
  //           return;
  //         } 
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
    
  // }
  
  
  

  if (
    (to.name == "LoginPage" || to.name == "home") &&
    store.state.isLoggedIn == true
  ) {
    next({ name: "WebpagesPage" });
    return;
  }
  next();
});

export default router;
